import React from "react";
import { Link } from "react-router-dom";
import SyncLogsTable from "../../../components/ClientDashboard/PosSync/SyncLogsTable";

const SyncLogs = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Sync Logs</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/">
              <i className="material-symbols-outlined">home</i>
              Home
            </Link>
          </li>
          <li>Sync Logs</li>
        </ul>
      </div>

      {/* Content */}
      <div className="posSync-content">
        <SyncLogsTable />
      </div>
    </>
  );
};

export default SyncLogs;

